import { gql } from '@apollo/client';

export const UPDATE_CREATIVE_TAGS = gql`
    mutation UpdateCreativeTags($updateCreativeTagsNode: UpdateCreativeTagsNode!) {
        updateCreativeTags(updateCreativeTagsNode: $updateCreativeTagsNode) {
            ok
            message
        }
    }
`;
